import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import _ from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';
import queryString, { ParsedQuery } from 'query-string';
import { bindActionCreators, Dispatch } from 'redux';
import moment from 'moment';
import 'moment/locale/pt';
import Cookies from 'js-cookie';
import cookie from 'cookie';
import { LDFlagSet } from 'launchdarkly-react-client-sdk';

// Contexts
import { withNavigation, withTranslate } from '../../../core/TenantProvider';
import withFlags from '../../../core/FlagsProvider';
// Components - Atoms, Organisms,Containers
import APButton from '../../atoms/APButton';
import APLabel from '../../atoms/APLabel';
import APSearchBar from '../APSearchBar';
import { APNotificationBell } from '../../atoms/APNotificationBell';
import { APReferralsSearchBar } from '../../atoms/APReferralsSearchBar';
import { APUserProfileManagementMenu } from '../APUserProfileManagementMenu';
import APSelect from '../../atoms/APSelect';
// Files in the same folder
import APHeaderStyles from './styles/APHeader.style';
import { ReactComponent as OverflowIcon } from './assets/icons/overflowmenuvertical.svg';
// Types
import { SectionWiseFlagObject } from '../../../core/types/FlagsTypes';
import { AffiliateDetailsAttributes, RoleAccessFunction } from '../../../core/types/AffiliateDetails';
import { LanguageType } from '../../../core/types/GeneralTypes';
import { DialingCodeState } from '../../../redux/modules/dialingCode/types';
// Reducer
import { ReducerState } from './../../../redux/modules';
import { actions as NotificationsActions } from '../../../redux/modules/notifications';
import { actions as SlidingRightPanelActions } from '../../../redux/modules/uistates';
import { actions as UserActions } from '../../../redux/modules/user';
import { actions as DialingCodeActions } from '../../../redux/modules/dialingCode'
// Utils
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { getConfigProperty } from '../../../core/EnvironmentConfig/EnvironmentConfig';
import { getReferringCompany } from '../../../core/utils/ReferringCompanyValueGetter/ReferringCompanyValueGetter';
// Constants
import {
	APPROVE_PARTNER,
	DEFAULT_LANGUAGE,
	LEGAL_ENTITY,
	SSO_CDH_COMPANY_KEY
} from '../../../core/utils/Constants/Constants';

interface APHeaderProps extends WithStyles<typeof APHeaderStyles> {
	isAuthenticated: boolean | null,
	translate: Function,
	location: any,
	navigate: any,
	getUnreadNotificationsCount: Function,
	unreadNotificationsCount: number,
	toggleSlidingRightPanelStatus: Function,
	updateLaunchDarklyFlagObject: Function,
	isMaintenanceModeOn: boolean | null,
	updateTranslations: Function,
	affiliateDetails: AffiliateDetailsAttributes | null,
	language: LanguageType,
	roleAccessFunction: RoleAccessFunction,
	isSuperUser: boolean,
	flags?: LDFlagSet;
	dialingCode?: DialingCodeState;
	getLocationDialingCode: Function
}

type PreferredLanguageType = 'en' | 'pt';

interface APHeaderState {
	mobileNavOpen: boolean;
	wrapperRef: any;
	enableReferralSearch: boolean;
	portalLanguage: PreferredLanguageType;
}

class APHeader extends Component<APHeaderProps, APHeaderState> {

	constructor(props: APHeaderProps) {
		super(props);

		moment.locale(this.props.language);

		this.state = {
			mobileNavOpen: false,
			wrapperRef: React.createRef(),
			enableReferralSearch: false,
			portalLanguage: DEFAULT_LANGUAGE
		};

		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.updateTranslationData = this.updateTranslationData.bind(this);
		this.handleReferralClick = this.handleReferralClick.bind(this);
		this.makeReferral = this.makeReferral.bind(this);
		this.handleMobileClick = this.handleMobileClick.bind(this);
		this.onSearchClick = this.onSearchClick.bind(this);
		this.onLanguageChange = this.onLanguageChange.bind(this);
		this.checkLanguagePreference = this.checkLanguagePreference.bind(this);
		this.clearSSOCookies = this.clearSSOCookies.bind(this);
	}

	updateTranslationData = (affiliateDetails: AffiliateDetailsAttributes | null) => {
		const { affiliate: { legal_entity = '', billing_country = '' } = {} } = affiliateDetails || {};
		const { ctry, le }: ParsedQuery<string> = queryString.parse(this.props.location.search);

		let translationLE: string = legal_entity || '',
			translationBillCountry: string = billing_country || '';

		if (window.location.href.indexOf(APPROVE_PARTNER) >= 0 && (translationLE === '' && ctry && le)) {
			translationLE = le as string;
			translationBillCountry = ctry as string;
		}
		if (LEGAL_ENTITY.includes(translationLE)) {
			const userSelectedLanguage: string | null = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE;

			this.props.updateTranslations(userSelectedLanguage, translationLE, translationBillCountry);
		}
	}

	checkLanguagePreference = () => {
		const { updateTranslations } = this.props;

		const { LANGUAGE_DROPDOWN }: SectionWiseFlagObject = getConfigProperty('featureFlags');

		const { portalLanguage } = this.state;

		const userSelectedLanguage: string | null = LANGUAGE_DROPDOWN ? localStorage.getItem('preferredLanguage') : DEFAULT_LANGUAGE;

		if (!userSelectedLanguage || !LANGUAGE_DROPDOWN) {
			localStorage.setItem('preferredLanguage', portalLanguage);
		} else if (userSelectedLanguage !== portalLanguage) {
			this.setState({ portalLanguage: userSelectedLanguage as PreferredLanguageType }, () => {
				updateTranslations(userSelectedLanguage);
			});
		}
	}

	componentDidMount(): void {
		const {
			isAuthenticated,
			getUnreadNotificationsCount,
			affiliateDetails,
			dialingCode,
			getLocationDialingCode,
			flags } = this.props;

		document.addEventListener('mousedown', this.handleClickOutside);
		isAuthenticated && affiliateDetails?.affiliate?.affiliate_Number && getUnreadNotificationsCount();

		this.updateTranslationData(affiliateDetails);
		this.checkLanguagePreference();
		!isAuthenticated && this.clearSSOCookies();

		if (flags) {
			this.props.updateLaunchDarklyFlagObject(flags);
		}

		const currentReferringCompany = getReferringCompany();
		if (dialingCode && !dialingCode.locationDialingCodeData && !isAuthenticated && currentReferringCompany !== 'undefined' && currentReferringCompany) {
			getLocationDialingCode();
		}

	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside(event) {
		if (!this.props.isAuthenticated && this.state.wrapperRef && !this.state.wrapperRef.current.contains(event.target)) {
			this.setState({
				mobileNavOpen: false
			});
		}
	}

	clearSSOCookies() {
		const ssoCdhCompany: string = cookie.parse(document.cookie)[SSO_CDH_COMPANY_KEY];

		if (ssoCdhCompany) {
			Cookies.remove(SSO_CDH_COMPANY_KEY, { path: '/' });
			Cookies.remove('affiliate-id', { path: '/' });
			Cookies.remove('affiliate-number', { path: '/' });
			sessionStorage.removeItem('affiliate-number');
			sessionStorage.removeItem('authenticated_by_octa');
			sessionStorage.removeItem('affiliate-id');

			window.location.reload();
		}
	}

	componentDidUpdate(prevProps: Readonly<APHeaderProps>, prevState: Readonly<{}>, snapshot?: any): void {
		const {
			isAuthenticated,
			getUnreadNotificationsCount,
			affiliateDetails,
			flags } = this.props;

		const {
			affiliateDetails: prevAffiliateDetails,
			isAuthenticated: prevIsAuthenticated,
			flags: prevFlags,
		} = prevProps || {};

		(prevIsAuthenticated !== isAuthenticated && affiliateDetails?.affiliate?.affiliate_Number) && getUnreadNotificationsCount();
		(prevIsAuthenticated !== isAuthenticated) && this.clearSSOCookies();

		if (!(_.isEqual(prevAffiliateDetails, affiliateDetails))) {
			const affiliateNumber: string | undefined = affiliateDetails?.affiliate?.affiliate_Number;
			const prevAffiliateNumber: string | undefined = prevAffiliateDetails?.affiliate?.affiliate_Number;

			if (affiliateNumber && prevAffiliateNumber !== affiliateNumber) {
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.partnerId.name,
					GoogleAnalytics4Tags.eventAction.load,
					GoogleAnalytics4Tags.partnerId.load.affiliateID,
					{ affiliateID: affiliateNumber }
				);
			}

			this.updateTranslationData(affiliateDetails);
		}

		if (prevProps.language !== this.props.language) {
			moment.locale(this.props.language);
		}

		if (prevFlags !== flags && flags) {
			this.props.updateLaunchDarklyFlagObject(flags);
		}
	}

	handleReferralClick = (e) => {
		e.preventDefault();
		TriggerGoogleAnalyticsTag(
			GoogleAnalyticTags.eventAction.click,
			GoogleAnalyticTags.globalCTAs.click.sendRegistrationLink
		);
		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.globalCTAs.name,
			GoogleAnalytics4Tags.eventAction.click,
			GoogleAnalytics4Tags.globalCTAs.click.sendRegistrationLink
		);
		this.props.toggleSlidingRightPanelStatus(true, 'referralForm');

		TriggerGoogleAnalyticsTag(
			GoogleAnalyticTags.eventAction.load,
			GoogleAnalyticTags.registerClient.load.referralURLGeneratorPageLoad
		);
		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.referralUrlGenerator.name,
			GoogleAnalytics4Tags.eventAction.load,
			GoogleAnalytics4Tags.referralUrlGenerator.load.referralURLGeneratorPageLoad
		);
	}

	makeReferral = (e) => {
		e.preventDefault();

		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.globalCTAs.name,
			GoogleAnalytics4Tags.eventAction.click,
			GoogleAnalytics4Tags.globalCTAs.click.makeAReferral
		);

		this.props.navigate('/refer')
	}

	registerClient = (e) => {
		e.preventDefault();
		this.props.navigate('/register_client')
	}

	handleMobileClick = (e) => {
		e.preventDefault();

		this.setState(prevState => ({
			mobileNavOpen: !prevState.mobileNavOpen
		}));
	}

	onSearchClick = () => {
		this.setState({ enableReferralSearch: !this.state.enableReferralSearch });
	}

	onLanguageChange = (event) => {
		this.setState({ portalLanguage: event.target.value });

		this.props.updateTranslations(event.target.value);

		localStorage.setItem('preferredLanguage', event.target.value);

		window.location.reload();
	}

	render() {
		const {
			classes,
			isAuthenticated,
			translate,
			unreadNotificationsCount,
			isMaintenanceModeOn,
			navigate,
			roleAccessFunction,
			flags,
			dialingCode,
			isSuperUser,
		} = this.props;

		const { wrapperRef, mobileNavOpen, enableReferralSearch } = this.state;
		const { LANGUAGE_DROPDOWN }: SectionWiseFlagObject = getConfigProperty('featureFlags');
		const { VIEW_NOTIFICATIONS } = roleAccessFunction;

		const headerLeftCls = classnames(classes.headerLeft, {
			[classes.headerLeftAuthenticated]: isAuthenticated,
			[classes.referralsSearchOpen]: enableReferralSearch
		});

		const headerLogoCls = classnames(classes.headerLogoLink, {
			[classes.headerLogoLinkLoggedIn]: isAuthenticated,
			[classes.logoWithReferralsSearch]: enableReferralSearch
		});

		const headerCls = classnames(classes.headerContainer, {
			[classes.headerContainerLoggedIn]: isAuthenticated
		});

		const url = window.location.href;
		const isSearchEnable: boolean = url.indexOf("/referrals") >= 0;
		const isLanguageDropdownEnable: boolean = url.indexOf("/login") >= 0 && !!LANGUAGE_DROPDOWN;
		const becomePartnerURL: string = '/register';

		if (!isSearchEnable && enableReferralSearch) {
			this.onSearchClick();
		}

		const isUsaLocation: boolean = dialingCode?.locationDialingCodeData?.countryCode3d === 'USA';

		const normalHeaderView = (
			<div className={headerCls}>
				<div className={headerLeftCls}>

					<div className={headerLogoCls}>
						<Link to={isAuthenticated ? '/account' : '/login'}>Home</Link>
					</div>

					{isAuthenticated && !enableReferralSearch && !isSuperUser && (
						<div className={classes.loggedInDesktopBtns}>
							<APButton
								className={classes.headerButton}
								variant="contained"
								onClick={this.handleReferralClick}
								color={"primary"}
							>
								{translate('header.action.send.registration.link')}
							</APButton>
							<APButton
								className={classes.headerButton}
								variant="contained"
								onClick={this.makeReferral}
								color="primary"
							>
								{translate('header.action.make.referral')}
							</APButton>
						</div>
					)}
					{isAuthenticated && isSearchEnable && (
						enableReferralSearch && <APSearchBar hideSearchBar={this.onSearchClick} />
					)}

				</div>
				<div className={classes.headerRight}>
					{/* Logged in */}
					{isAuthenticated &&
						<>
							{isSearchEnable && !enableReferralSearch &&
								<APReferralsSearchBar onSearchClick={this.onSearchClick} />}
							{VIEW_NOTIFICATIONS && <APNotificationBell unreadCount={unreadNotificationsCount} />}
							<APUserProfileManagementMenu />
						</>
					}
					{/* Logged out */}
					{!isAuthenticated &&
						<>
							<button className={classes.loggedOutMobileBtn} onClick={this.handleMobileClick}>
								<OverflowIcon />
							</button>
							<div ref={wrapperRef} className={(mobileNavOpen) ? classes.loggedOutRight + ' mobileNavOpen' : classes.loggedOutRight}>
								<APLabel className={classes.contactDetails}>{isUsaLocation ? translate('header.contact.phone.usa') : translate('header.contact.phone')}</APLabel>
								{url.indexOf(becomePartnerURL) === -1 && flags?.bapFlowAccess &&
									<APButton className={classes.headerButton}
										onClick={() => this.setState(
											{ mobileNavOpen: false },
											() => {
												TriggerGoogleAnalyticsTag(
													GoogleAnalyticTags.eventAction.click,
													GoogleAnalyticTags.login.click.becomeAPartnerCTA
												);
												TriggerGoogleAnalytics4Tag(
													GoogleAnalytics4Tags.login.name,
													GoogleAnalytics4Tags.eventAction.click,
													GoogleAnalytics4Tags.login.click.becomeAPartnerCTA
												);
												navigate(becomePartnerURL);
											}
										)
										}
										variant="contained" color="primary">
										{translate('header.action.register')}
									</APButton>
								}
								{isLanguageDropdownEnable &&
									<div className={classes.headerPortalLanguageDropdown}>
										<APSelect
											className={'languageSelectDropdown'}
											name={'portalLanguage'}
											disableClearValue
											onChange={this.onLanguageChange}
											type={'portalLanguage'}
											value={this.state.portalLanguage}
										/>
									</div>}
							</div>
						</>
					}
				</div>
			</div>
		);

		const plainHeaderView = (
			<div className={headerCls}>
				<div className={headerLeftCls}>
					<div className={headerLogoCls}>
						<Link to={'/login'}>Home</Link>
					</div>
				</div>
				<div className={classes.headerRight}>
					<button className={classes.loggedOutMobileBtn} onClick={this.handleMobileClick}>
						<OverflowIcon />
					</button>
					<div ref={wrapperRef} className={(mobileNavOpen) ? classes.loggedOutRight + ' mobileNavOpen' : classes.loggedOutRight}>
						<APLabel className={classes.contactDetails}>{translate('header.contact.phone')}</APLabel>
					</div>
				</div>
			</div>
		);

		const maintenanceHeaderView = (
			<div className={headerCls}>
				<div className={headerLeftCls}>
					<div className={headerLogoCls}>
						<Link to={'/maintenance'}>Home</Link>
					</div>
				</div>
				<div className={classes.headerRight}>
					<button className={classes.loggedOutMobileBtn} onClick={this.handleMobileClick}>
						<OverflowIcon />
					</button>
					<div ref={wrapperRef} className={(mobileNavOpen) ? classes.loggedOutRight + ' mobileNavOpen' : classes.loggedOutRight}>
						<APLabel className={classes.contactDetails}>{translate('header.contact.phone')}</APLabel>
					</div>
				</div>
			</div>
		);

		return (
			<>
				{isMaintenanceModeOn ? (maintenanceHeaderView) : ((url.indexOf(APPROVE_PARTNER) >= 0) ? plainHeaderView : normalHeaderView)}
			</>
		);
	}
}

const mapStateToProps = (store: ReducerState) => ({
	isAuthenticated: store.user.isAuthenticated,
	unreadNotificationsCount: store.notifications.unreadCount,
	affiliateDetails: store.user.affiliateDetails,
	isMaintenanceModeOn: store.servicesDowntime.isMaintenanceModeOn,
	roleAccessFunction: store.user.roleAccessFunction,
	dialingCode: store.dialingCode,
	isSuperUser: store.user.isSuperUser
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	toggleSlidingRightPanelStatus: SlidingRightPanelActions.toggleSlidingRightPanelStatus,
	getUnreadNotificationsCount: NotificationsActions.getUnreadNotificationsCount,
	updateLaunchDarklyFlagObject: UserActions.updateLaunchDarklyFlagObject,
	getLocationDialingCode: DialingCodeActions.getLocationDialingCode
}, dispatch);

export default (
	withNavigation(
		withFlags(
			withTranslate(
				withStyles(APHeaderStyles)(
					connect(mapStateToProps, mapDispatchToProps)(APHeader)
				)
			)
		)
	)
);
